import { useQuery } from 'react-query';
import { RiskOverviewMetrics } from '../../models/RiskProducts';
import { fetchCompanyRiskOverview } from '../../services/riskProducts/riskProducts.service';
import { queryKeys } from '../queryKeyFactory';

export interface UseFetchRiskOverviewQuery {
  isLoading: boolean;
  isError: boolean;
  data?: RiskOverviewMetrics;
  refetch: () => void;
}

export default (companyId: string): UseFetchRiskOverviewQuery => {
  return useQuery<RiskOverviewMetrics, Error>(
    queryKeys.fetchRiskProducts.overview(companyId),
    async () => fetchCompanyRiskOverview(companyId),
    { retry: false }
  );
};
